import { render, staticRenderFns } from "./MembersProfile.vue?vue&type=template&id=038a3e8a&"
import script from "./MembersProfile.vue?vue&type=script&lang=js&"
export * from "./MembersProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports